import { render, staticRenderFns } from "./PricingDesktopAnnual.vue?vue&type=template&id=32a54908&scoped=true&"
import script from "./PricingDesktopAnnual.vue?vue&type=script&lang=js&"
export * from "./PricingDesktopAnnual.vue?vue&type=script&lang=js&"
import style0 from "./PricingDesktopAnnual.vue?vue&type=style&index=0&id=32a54908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a54908",
  null
  
)

export default component.exports